import { FormRule } from 'antd'

export function ruleRequiredOneOf(fields: string[], errorMessage: string): FormRule {
  return (form: any) => ({
    validator: () => {
      for (const field of fields) {
        const value = form.getFieldValue(field)
        if (Array.isArray(value) ? value.length > 0 : !!value) {
          return Promise.resolve()
        }
      }
      return Promise.reject(errorMessage)
    }
  })
}

export const ruleExtraId: FormRule = {
  message: 'pattern: [a-z][0-9][_-]',
  pattern: /^[a-z0-9_-]+$/g,
}
